<template>
  <div class="header">
    <Header></Header>
    <!-- banner -->
    <div ref="box" class="box">
        <img src="../../assets/picture/contact/interviewtips.png">
    </div>
    <!-- footer -->
     <div class="footer phoneShow">
        <div class="container">
          <p>&copy;{{copyright}}</p>
          <p>(<a target="_blank" href="http://beian.miit.gov.cn/">{{icpNumber}}</a>）</p>
        </div>
    </div>
  </div>
</template>

<script>
import Header from '../common/header';
export default {
  data() {
    return {
      isShowSearch:false,
      icpNumber:'',
      copyright:'',
    };
  },
  components: { Header },
  mounted(){
    this.getConfig();
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     //获取基础配置信息
    async getConfig() {
        const { data: res } = await this.$http.get("/config/getConfig.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.copyright = res.data.copyright;
        this.icpNumber = res.data.icpNumber;
      },
  }
};
</script>

<style lang="less" scoped>
.header{
  width: 100%;
    height: 100%;
  .box{
   /* background-image: url(../../assets/picture/contact/interviewtips.png);
    background-position: center center;
    background-size: cover;*/
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    img{
      width: 100%;
      max-width: 900px;
      margin:0 auto;
      display: block;
    }
  }
    .footer{
    width: 100%;
    background: #1E1E1E;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #F2F2F2;
    line-height: 20px;
    padding:20px 18px;
    a,a:hover{
      font-weight: 500;
      color: #F2F2F2;
    }
  }
}
</style>
